import { Lock, LifeBuoy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTE } from '@/config';
import { Button } from '@/components/ui/button';

/**
 * Item 1 — Lock Shipping Rules.
 *
 * Shown on the shipping-rules and carriers settings pages when the merchant's
 * `lock_shipping_rules` flag is true. The flag is set only by Boxy admin and
 * is read-only for the merchant — so the banner explains the contract and
 * routes the merchant to the ticket center to raise a question.
 */
export function ShippingLockBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className='rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
      <div className='flex items-start gap-3'>
        <Lock className='h-4 w-4 mt-0.5 shrink-0 text-amber-600' strokeWidth={1.75} />
        <div>
          <div className='text-sm font-semibold text-amber-900'>
            {String(t('shipping_rules.lock_banner_title'))}
          </div>
          <div className='text-xs text-amber-800 mt-0.5'>
            {String(t('shipping_rules.lock_banner_body'))}
          </div>
        </div>
      </div>
      <Button
        onClick={() => navigate(ROUTE.TICKET_CENTER)}
        className='h-9 gap-1.5 text-xs font-semibold shrink-0 bg-amber-600 text-white hover:bg-amber-700'
      >
        <LifeBuoy className='h-4 w-4' />
        {String(t('shipping_rules.lock_banner_cta'))}
      </Button>
    </div>
  );
}
